import { MobileAppBanner } from "@app/mobile-app/components";
import { OfflineDuesBanner } from "@app/session-history/components/OfflineDuesBanner";
import { useFeatureFlag } from "@app/shared/hooks/use-feature-flag";
import { cn } from "@design-system/lib/utils";
import { DarkModeToggle } from "../../DarkModeToggle";
import { UnlockCodeButton } from "../../UnlockCodeButton";
import { HeaderNavLinks } from "./HeaderNavLinks";
import { HeaderLogo } from "./HeaderLogo";
import { InquiriesShortcut } from "./InquiriesShortcut";
import { HeaderTopBar, HeaderUserMenu, NotificationsBell } from "./index";

type HeaderDesktopProps = {
  isScrolled: boolean;
};

export function HeaderDesktop({ isScrolled }: HeaderDesktopProps) {
  const isDarkModeFeatureEnabled = useFeatureFlag("darkMode");
  const isNotificationsFeatureEnabled = useFeatureFlag("notifications");

  return (
    <>
      <header
        className={cn(
          "sticky top-0 z-40 w-full border-b border-slate-200/70 bg-white/[0.88] backdrop-blur-xl transition-[background-color,box-shadow,border-color] duration-300 dark:border-slate-800/70 dark:bg-slate-950/[0.88]",
          isScrolled &&
            "border-slate-200/90 bg-white/95 shadow-[0_12px_40px_-24px_rgba(15,23,42,0.45)] dark:border-slate-800 dark:bg-slate-950/95",
        )}
      >
        {/* Top Bar */}
        <MobileAppBanner />
        <OfflineDuesBanner />
        <HeaderTopBar />

        {/* Main Header Content */}
        <div>
          <div className="container mx-auto flex h-[4.5rem] max-w-[112rem] items-center justify-between gap-4 px-4 sm:px-6 lg:px-8">
            {/* Logo & Brand */}
            <div className="flex items-center">
              <HeaderLogo />
            </div>

            {/* Navigation Links (overflow goes into "More") */}
            <HeaderNavLinks />

            {/* Right Actions */}
            <div className="flex shrink-0 items-center gap-2 rounded-2xl border border-slate-200/80 bg-white/70 p-1.5 shadow-sm dark:border-slate-800 dark:bg-slate-900/70">
              {/* Teaching Language Switcher - Desktop */}
              {/* <div className="hidden sm:block">
                <TeachingLanguageSwitcher />
              </div> */}

              {/* Dark Mode Toggle */}
              {isDarkModeFeatureEnabled && (
                <DarkModeToggle variant="switch" size="sm" />
              )}

              <UnlockCodeButton variant="outline" size="sm" responsive />
              <InquiriesShortcut />
              {isNotificationsFeatureEnabled && <NotificationsBell />}
              <HeaderUserMenu />
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
